import { useQueryClient } from 'react-query';
import request from '../../helpers/request';
import { queryKeys } from '../queryKeys';
import { withCancelToken } from '../helpers/withCancelToken';
import { useCallback } from 'react';

const fetcher = ({ addressId, fileName }, source) => {
  return request.get(
    `/HousingStock/address/${addressId}/attachment`,
    { fileName },
    'При загрузке вложения произошла ошибка',
    'Error',
    undefined,
    undefined,
    { cancelToken: source.token }
  );
};

const cancelableFetcher = (params) => {
  return withCancelToken((source) => fetcher(params, source));
};

const useFetchRoomAttachment = (addressId) => {
  const queryClient = useQueryClient();

  return useCallback(
    async ({ fileName }, options) => {
      const params = { addressId, fileName };

      return await queryClient.fetchQuery(
        queryKeys.flatAttachment(params),
        () => cancelableFetcher(params),
        {
          staleTime: Infinity,
          ...options,
        }
      );
    },
    [addressId, queryClient]
  );
};

export { useFetchRoomAttachment };
